// postcss-px2rem配置之----对html的font-size进行动态设置
window.onload = function() {
  document.addEventListener("touchstart", function(event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  var lastTouchEnd = 0;
  document.addEventListener(
    "touchend",
    function(event) {
      var now = new Date().getTime();
      if (now - lastTouchEnd <= 300) {
        event.preventDefault();
      }
      lastTouchEnd = now;
    },
    false
  );
  document.addEventListener("gesturestart", function(event) {
    event.preventDefault();
  });
};

const usesDesktopRem = !/mobile/i.test(navigator.userAgent);
let desktopRemBase = 100;
let hasDesktopRemOverride = false;

function refreshRem() {
  if (!usesDesktopRem && !hasDesktopRemOverride) return;
  const designWidth = 1920;
  const html = document.documentElement;
  html.style.fontSize =
    (html.clientWidth * desktopRemBase) / designWidth + "px";
}

export function useDesktopRemBase(base) {
  const previousBase = desktopRemBase;
  const previousOverride = hasDesktopRemOverride;
  desktopRemBase = base;
  hasDesktopRemOverride = true;
  refreshRem();
  return () => {
    desktopRemBase = previousBase;
    hasDesktopRemOverride = previousOverride;
    if (usesDesktopRem || hasDesktopRemOverride) {
      refreshRem();
    } else {
      window.lib.flexible.refreshRem();
    }
  };
}

(function(win) {
  var tid;
  // iPad uses the PC component despite its Mobile UA; honor an active override.
  win.addEventListener(
    "resize",
    function() {
      clearTimeout(tid);
      tid = setTimeout(refreshRem, 300);
    },
    false
  );
  win.addEventListener(
    "pageshow",
    function(e) {
      if (e.persisted) {
        clearTimeout(tid);
        tid = setTimeout(refreshRem, 300);
      }
    },
    false
  );
  refreshRem();
})(window);
